import { BusinessRulesDTO } from "@lg-cfa/services";
import { atom } from "recoil";

import { persistAtom } from "@states/persist";

export const businessRulesState = atom<BusinessRulesDTO | undefined>({
    key: "businessRulesState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});
